import { ErrorMessage, Field, Form, Formik } from "formik";
import moment from "moment";
// import { useMemo } from "react";
import * as Yup from "yup";
import useSearchFlights, {
  SearchFlightsPayload,
} from "../../../hooks/useSearchFlights";
import { HashLoader } from "react-spinners";
// import useIntlAirlines from "../../../hooks/useIntlAirlines";
import AirportSelector from "../../../components/AirportSelector";
import { AnimatePresence, motion } from "framer-motion";
import PassengerSelector from "../../../components/PassengerSelector";
import { useNavigate } from "react-router-dom";

// ✅ Yup validation schema
const validationSchema = Yup.object().shape({
  journeyType: Yup.string().required("Journey type is required"),
  class: Yup.string().required("Class is required"),
  departureDate: Yup.string()
    .required("Departure date is required")
    .test(
      "is-future",
      "Departure date must be in the future",
      function (value) {
        return moment(value).isSameOrAfter(moment().format("YYYY-MM-DD"));
      }
    ),
  returnDate: Yup.string().when(["journeyType"], ([journeyType], schema) => {
    if (journeyType === "Return") {
      console.log(journeyType);

      return schema
        .required("Return date is required")
        .test(
          "is-future",
          "Return date must be the same or after the departure date",
          function (value) {
            const { departureDate } = this.parent;
            if (!value || !departureDate) return false;
            return moment(value).isSameOrAfter(moment(departureDate), "day");
          }
        );
    }
    return schema.notRequired();
  }),
  airportOriginCode: Yup.string().required("Origin airport is required"),
  airportDestinationCode: Yup.string()
    .required("Destination airport is required")
    .notOneOf(
      [Yup.ref("airportOriginCode")],
      "Origin and destination cannot be the same"
    ),
  infants: Yup.number().min(0).max(5),
  adults: Yup.number().min(1, "At least one adult is required").max(9),
  children: Yup.number().min(0).max(9),
});

const journeyTypes = [
  {
    title: "One Way",
    key: "OneWay",
  },
  {
    title: "Return",
    key: "Return",
  },
  {
    title: "Circle",
    key: "Circle",
  },
];

const classes = ["Economy", "PremiumEconomy", "Business", "First"];

const SearchFlight = () => {
  // const { airlinesData, isLoading: isFetchingIntlAirlines } = useIntlAirlines();

  const navigate = useNavigate();

  // const dedupedSortedAirlines = useMemo(() => {
  //   if (!airlinesData?.data) return [];

  //   const uniqueMap = new Map();
  //   for (const airline of airlinesData.data) {
  //     uniqueMap.set(airline.AirLineCode, airline);
  //   }

  //   return Array.from(uniqueMap.values()).sort((a, b) =>
  //     a.AirLineName.localeCompare(b.AirLineName)
  //   );
  // }, [airlinesData?.data]);

  const { searchFlights, searchingFlights } = useSearchFlights({
    onSuccess(data, variables) {
      if (data.data) {
        navigate("/aviation/international/search-results", {
          state: {
            searchResults: {
              data: data.data,
              ...variables,
            },
          },
        });
      }
    },
  });

  return (
    <div>
      {searchingFlights && (
        <div className="fixed top-0 z-50 left-0 h-screen w-screen flex items-center justify-center bg-black/20 backdrop-blur-sm">
          <HashLoader />
        </div>
      )}
      <Formik
        validationSchema={validationSchema}
        initialValues={{
          journeyType: "OneWay",
          class: "Economy",
          departureDate: moment(new Date()).format("yyyy-MM-DD"),
          returnDate: moment(new Date()).format("yyyy-MM-DD"),
          airportOriginCode: "",
          airlineCode: "",
          airportDestinationCode: "",
          infants: 0,
          adults: 1,
          children: 0,
        }}
        onSubmit={(values) => {
          searchFlights(values as SearchFlightsPayload);
        }}
      >
        {({ setFieldValue, values }) => (
          <div className="flex-col gap-4 flex items-start justify-center max-w-3xl mx-auto w-full py-10">
            <Form className="bg-white p-5 border border-gray-200 rounded-md w-full flex flex-col gap-5">
              <h1 className="text-2xl font-medium">
                Book upcoming international flights
              </h1>

              <div className="flex">
                {journeyTypes.map((journeyType) => {
                  return (
                    <button
                      type="button"
                      onClick={() =>
                        setFieldValue("journeyType", journeyType.key)
                      }
                      key={journeyType.key}
                      className={`p-3 px-4 border text-sm first:rounded-l-lg last:rounded-r-lg flex-1 w-full font-medium ${
                        values.journeyType === journeyType.key
                          ? "bg-gray-100 text-visaro-orange"
                          : "bg-transparent"
                      }`}
                    >
                      {journeyType.title}
                    </button>
                  );
                })}
              </div>
              <div className="grid grid-cols-2 gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <label
                    htmlFor="airportOriginCode"
                    className="text-sm font-bold text-gray-700"
                  >
                    Depature
                  </label>
                  <AirportSelector
                    onSelect={(airport) =>
                      setFieldValue("airportOriginCode", airport.AirportCode)
                    }
                    placeholder="Enter Depature City"
                  />
                  {/* <Field
                      as="select"
                      id="airportOriginCode"
                      name="airportOriginCode"
                      className="rounded-lg border border-gray-300 shadow px-4 py-3 w-full"
                    >
                      <option value="" disabled>
                        {isFetchingIntlAirports
                          ? "Loading Airports...."
                          : "Select Origin"}
                      </option>
                      {dedupedSortedAirports.map((airport) => (
                        <option
                          key={airport.AirportCode}
                          value={airport.AirportCode}
                        >
                          {airport.AirportName} - {airport.City},
                          {airport.Country}
                        </option>
                      ))}
                    </Field> */}
                  <ErrorMessage
                    name="airportOriginCode"
                    component="div"
                    className="text-red-500"
                  />
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <label
                    htmlFor="airportOriginCode"
                    className="text-sm font-bold text-gray-700"
                  >
                    Destination
                  </label>
                  <AirportSelector
                    onSelect={(airport) =>
                      setFieldValue(
                        "airportDestinationCode",
                        airport.AirportCode
                      )
                    }
                    placeholder="Enter Destination City"
                    isDepature={false}
                  />
                  {/* <Field
                      as="select"
                      id="airportDestinationCode"
                      name="airportDestinationCode"
                      className="rounded-lg border border-gray-300 shadow px-4 py-3 w-full"
                    >
                      <option value="" disabled>
                        {isFetchingIntlAirports
                          ? "Loading Airports...."
                          : "Select Destination"}
                      </option>
                      {dedupedSortedAirports.map((airport) => (
                        <option
                          key={airport.AirportCode}
                          value={airport.AirportCode}
                        >
                          {airport.AirportName} - {airport.City},
                          {airport.Country}
                        </option>
                      ))}
                    </Field> */}
                  <ErrorMessage
                    name="airportDestinationCode"
                    component="div"
                    className="text-red-500"
                  />
                </div>
              </div>
              {/* <div className="flex flex-col gap-2 w-full">
                <label
                  htmlFor="airlineCode"
                  className="text-sm font-bold text-gray-700"
                >
                  Preferred Airline
                </label>
                <Field
                  as="select"
                  id="airlineCode"
                  disabled={isFetchingIntlAirlines}
                  name="airlineCode"
                  className="rounded-lg border border-gray-300 shadow px-4 py-3 w-full disabled:cursor-progress"
                >
                  <option value="" disabled>
                    {isFetchingIntlAirlines
                      ? "Loading Airlines...."
                      : "Select Airline"}
                  </option>
                  {dedupedSortedAirlines.map((airline) => (
                    <option
                      className="capitalize"
                      key={airline.AirLineCode}
                      value={airline.AirLineCode}
                    >
                      {airline.AirLineName}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  name="airlineCode"
                  component="div"
                  className="text-red-500"
                />
              </div> */}
              <div className="flex flex-col gap-2 w-full">
                <label
                  htmlFor="departureDate"
                  className="text-sm font-bold text-gray-700"
                >
                  Depature Date
                </label>
                <Field
                  type="date"
                  id="departureDate"
                  name="departureDate"
                  min={moment().format("YYYY-MM-DD")}
                  className="rounded-lg border border-gray-300 shadow px-4 py-3 w-full"
                />
                <ErrorMessage
                  name="departureDate"
                  component="div"
                  className="text-red-500"
                />
              </div>
              <AnimatePresence>
                {values.journeyType === "Return" && (
                  <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    className="flex flex-col gap-2 w-full"
                  >
                    <label
                      htmlFor="departureDate"
                      className="text-sm font-bold text-gray-700"
                    >
                      Return Date
                    </label>
                    <Field
                      type="date"
                      id="returnDate"
                      name="returnDate"
                      min={moment().format("YYYY-MM-DD")}
                      className="rounded-lg border border-gray-300 shadow px-4 py-3 w-full"
                    />
                    <ErrorMessage
                      name="returnDate"
                      component="div"
                      className="text-red-500"
                    />
                  </motion.div>
                )}
              </AnimatePresence>
              {/* Travel Class */}
              <div className="flex flex-col gap-2 w-full">
                <label
                  htmlFor="class"
                  className="text-sm font-bold text-gray-700"
                >
                  Cabin Class
                </label>
                <Field
                  as="select"
                  name="class"
                  id="class"
                  className="rounded-lg border border-gray-300 shadow px-4 py-3 w-full"
                >
                  {classes.map((cls) => (
                    <option key={cls} value={cls}>
                      {cls}
                    </option>
                  ))}
                </Field>
              </div>
              <div className="flex flex-col gap-2 w-full">
                <PassengerSelector />
              </div>

              <button
                type="submit"
                className="bg-visaro-orange text-white px-6 py-3 rounded-lg mt-4"
              >
                {searchingFlights ? "Searching..." : "Search Flights"}
              </button>
            </Form>
          </div>
        )}
      </Formik>
    </div>
  );
};

export default SearchFlight;
